import { PublicClientApplication } from '@azure/msal-browser';

const getRedirectUri = () => {
    // Use the current origin + /redirect in browser environments so the
    // popup can return to the app's redirect route and communicate back
    // to the opener. Fall back to known values for build-time contexts.
    if (typeof window !== 'undefined') {
        return `${window.location.origin}/redirect`;
    }
    if (process.env.NODE_ENV === 'production') {
        return 'https://nice-field-042841a0f.1.azurestaticapps.net/redirect';
    }
    return 'http://localhost:3000/redirect';
};

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/8f6e7663-4941-47ea-8db6-08c1d9a01ef0",
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: getRedirectUri(),
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        allowNativeBroker: false,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                console.log(message);
            },
            logLevel: "Info",
            piiLoggingEnabled: false,
        }
    }
};
  
export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
    prompt: 'select_account'
};

// Add these additional configurations
export const tokenRequest = {
    scopes: ['api://c4fd3511-e48b-4297-b3df-29d52496b8a7/.default']
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Create MSAL instance with explicit configuration
export const msalInstance = new PublicClientApplication({
    ...msalConfig,
    auth: {
        ...msalConfig.auth,
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/8f6e7663-4941-47ea-8db6-08c1d9a01ef0",
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: getRedirectUri(),
        navigateToLoginRequestUrl: true,
        clientCapabilities: ["CP1"],
        responseType: "id_token token"
    }
});
  
//service_xze3t4o
//template_pg1nwis